import HTTP from "../http";
import Jsona from "jsona";
import subscriptionStates from "@/utils/states/subscription";
import moment from "@/utils/moment";

const dataFormatter = new Jsona();

export default {
  async index(page, sort) {
    try {
      let results = await HTTP.normal.get(
        `/subscriptions?include=cycles,professional.account&page[number]=${page}&sort=-starts_at`
      );

      results = {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };

      results.data = subscriptionStates.filterCycles(results.data);
      results.data = subscriptionStates.sortCycles(results.data);
      results.data = subscriptionStates.sortByState(results.data);

      return results;
    } catch (e) {
      throw "Ocorreu um erro ao listar as assinaturas!";
    }
  },

  async requestSubscription(order, frequency) {
    const weekday = moment(order.schedule_event.starts_at).format("dddd");
    const initialHour = moment(order.schedule_event.starts_at).format("HH");

    try {
      const body = {
        name:
          order.customer.account.first_name +
          " " +
          order.customer.account.last_name,
        email: order.customer.account.email,
        phone: "não informado",
        type:
          order.customer.type == "physicals" ? "Residencial" : "Empresarial",
        frequency: frequency,
        days: [weekday],
        professional_name:
          order.professional.account.first_name +
          " " +
          order.professional.account.last_name,
        address: order.address.street,
        district: order.address.district.display_name,
        city: order.address.district.city.display_name,
        hours: order.schedule_event.duration / 60,
        initial_hour: initialHour,
        initial_date: "não definido"
      };

      const response = await HTTP.Subscription.post("/send", body);
    } catch (e) {
      console.log(e);
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/subscriptions.js